import { getXOpenxInstance } from '@openx/utils/lib/getXOpenxInstance';

const INSTANCE_PREFIXED_APPS = new Set(['DSP UI', 'OXControl']);

export const getInstancePrefixedAppName = (appName: string): string =>
  INSTANCE_PREFIXED_APPS.has(appName) ? `${getXOpenxInstance()} - ${appName}` : appName;
